import { render, staticRenderFns } from "./QueryCurrPortfolioMenu.vue?vue&type=template&id=0248e669&"
import script from "./QueryCurrPortfolioMenu.vue?vue&type=script&lang=js&"
export * from "./QueryCurrPortfolioMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports